import { FindyLogoLink } from '../../../components/findy-logo-link.component';
import { UserNameDropdownMenu } from '../../components/user-name-dropdown-menu/user-name-dropdown-menu.component';
import styles from './incomplete-profile-desktop-content.component.module.scss';

type Props = {
  userName: string;
  onLogout: () => void;
};

export const IncompleteProfileDesktopContent = ({
  userName,
  onLogout,
}: Props) => {
  return (
    <div className={styles.wrapper}>
      <FindyLogoLink />
      <UserNameDropdownMenu
        hideProfileMenu
        hideSettingsMenu
        userName={userName}
        onLogout={onLogout}
      />
    </div>
  );
};
